"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddedDateValue = exports.getSubtractedDateValue = exports.weekDateFormat = void 0;
const weekDateFormat = ({ rangeStart, rangeEnd, value, }) => {
    const isSelectedDateInStartMonth = value.isSame(rangeStart, 'month');
    const isDateRangeInSameMonth = rangeStart.isSame(rangeEnd, 'month');
    if (isDateRangeInSameMonth) {
        return `MMM [${rangeStart?.format('D')}] - [${rangeEnd?.format('D')}]`;
    }
    else {
        return isSelectedDateInStartMonth
            ? `MMM [${rangeStart?.format('D')}] - [${rangeEnd?.format('MMM D')}]`
            : `[${rangeStart?.format('MMM D')}] - MMM [${rangeEnd?.format('D')}]`;
    }
};
exports.weekDateFormat = weekDateFormat;
const time = {
    day: [1, 'd'],
    week: [7, 'd'],
    month: [1, 'M'],
    default: [1, 'd'],
};
// TODO: Deprecate moment methods for MDT
// https://medely.atlassian.net/browse/FAC-939
const getSubtractedDateValue = ({ value, variant, }) => {
    return value.clone().subtract(...time[variant]);
};
exports.getSubtractedDateValue = getSubtractedDateValue;
// TODO: Deprecate moment methods for MDT
// https://medely.atlassian.net/browse/FAC-939
const getAddedDateValue = ({ value, variant, }) => {
    return value.clone().add(...time[variant]);
};
exports.getAddedDateValue = getAddedDateValue;
